import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:0,type:'culture'},
    
  },
  mutations: {
    setFooter(state,data){
      if(data){
        if(data.page){
          state.footerData.page=data.page;
        }
        if(data.index){
          for(var i=0;i<state.nav.length;i++){
            state.nav[i].click="";
          }
          state.nav[data.index].click="on";
        }
        if(data.child){
           for(var i=0;i<state.nav.length;i++){
            state.nav[i].click="";
          }
          state.nav[data.index].click="";
          state.nav[data.index-1].child=data.child;
        }else{
          state.nav[data.index-1].child=data.child;
        }
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
